export default __webpack_public_path__ + "static/media/Skyshear Bracers.d05c6569.jpg";